import { useTranslation } from "react-i18next";

export default function RuleTrace({ rule }) {
    const { t } = useTranslation();
    const source = rule.sourceData || {};

    return (
        <div className="mt-2 border-t pt-3 space-y-3 text-sm">
            {rule.reasoning && (
                <div>
                    <h4 className="font-medium text-muted-foreground mb-1">
                        {t("admin.intelligence.rules.reasoning")}
                    </h4>
                    <p className="text-foreground bg-muted/50 rounded p-2">{rule.reasoning}</p>
                </div>
            )}
            {source.outcome && (
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
                    <TraceMetric label={t("admin.intelligence.rules.traceOutcome")} value={source.outcome} />
                    <TraceMetric label={t("admin.intelligence.rules.traceCount")} value={source.count} />
                    <TraceMetric label={t("admin.intelligence.rules.traceCompanies")} value={source.uniqueCompanies} />
                    <TraceMetric label={t("admin.intelligence.rules.traceAvgIterations")} value={source.avgIterations} />
                </div>
            )}
            {source.errorType && (
                <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
                    <TraceMetric label={t("admin.intelligence.rules.traceErrorType")} value={source.errorType} />
                    <TraceMetric label={t("admin.intelligence.rules.traceOccurrences")} value={source.totalOccurrences} />
                    <TraceMetric label={t("admin.intelligence.rules.traceCompanies")} value={source.uniqueCompanies} />
                </div>
            )}
            {source.sampleRequests?.length > 0 && (
                <div>
                    <h4 className="font-medium text-muted-foreground mb-1">
                        {t("admin.intelligence.rules.traceSampleRequests")}
                    </h4>
                    <ul className="space-y-1">
                        {source.sampleRequests.map((req, i) => (
                            <li key={i} className="bg-muted/50 rounded p-2 text-xs">{req}</li>
                        ))}
                    </ul>
                </div>
            )}
            {source.samplePreferences?.length > 0 && (
                <div>
                    <h4 className="font-medium text-muted-foreground mb-1">
                        {t("admin.intelligence.rules.traceSamplePreferences")}
                    </h4>
                    <ul className="space-y-1">
                        {source.samplePreferences.map((pref, i) => (
                            <li key={i} className="bg-muted/50 rounded p-2 text-xs">{pref}</li>
                        ))}
                    </ul>
                </div>
            )}
            {source.sampleErrors?.length > 0 && (
                <div>
                    <h4 className="font-medium text-muted-foreground mb-1">
                        {t("admin.intelligence.rules.traceSampleErrors")}
                    </h4>
                    <ul className="space-y-1">
                        {source.sampleErrors.map((err, i) => (
                            <li key={i} className="bg-muted/50 rounded p-2 text-xs">
                                {err.message} <span className="text-muted-foreground">({err.occurrences}x)</span>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
}

function TraceMetric({ label, value }) {
    return (
        <div className="bg-muted/50 rounded p-2">
            <div className="text-xs text-muted-foreground">{label}</div>
            <div className="font-medium">{value}</div>
        </div>
    );
}
